import Link from 'next/link'
import useTranslation from 'next-translate/useTranslation'

import BodyText from '../../../../app/components/BodyText'
import MiddotSeparator from '../../../../app/components/separator/MiddotSeparator'

import styles from './TermsAndPrivacyLinks.module.scss'

function TermsAndPrivacyLinks() {
  const { t } = useTranslation('common')

  return (
    <div className={styles.linksContainer}>
      <Link href="http://ancon.io/av.pdf" target="blank">
        <BodyText color="body-0">
          {t('components.footer.termsAndConditions')}
        </BodyText>
      </Link>
      <MiddotSeparator />
      <Link href="https://ancon.io/privacy-policy/" target="blank">
        <BodyText color="body-0">
          {t('components.footer.privacyPolicy')}
        </BodyText>
      </Link>
    </div>
  )
}

export default TermsAndPrivacyLinks
